import { Banner } from "../components/Banner";
import { Timer } from "../components/Timer";
import { Numbers } from "../components/Numbers";
import { Info } from "../components/Info/Info";
import { Partners } from "../components/Partners";
import { Maps } from "../components/Maps";
import { ProPab } from "../components/ProPab";
import { Promotion } from "../components/Promotion";
import { Gallery } from "../components/Gallery";
import { END_DATA } from "../../../constants/time";
import Bg from "../../../assets/img/secondary_bg.png";
import styles from "./MainPage.module.sass";
import { Tickets } from "../components/Tickets";

export const MainPage = () => {
  return (
    <div className={styles.root}>
      <Banner />
      <Timer targetDate={END_DATA} />
      <div className={styles.bg}>
        <img className={styles.bgImg} src={Bg} alt="bg" />
        <Numbers />
        <Info />
        <Tickets />
        <Partners />
      </div>
      <Maps />
      <ProPab />
      <Promotion />
      <Gallery />
    </div>
  );
};
